import { default as domainAgentSetting } from './setting/services'

export default {
    domainAgentSetting,
}